import { render, staticRenderFns } from "./DasButton.vue?vue&type=template&id=0505d5f4"
import script from "./DasButton.vue?vue&type=script&lang=js"
export * from "./DasButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports